import { RtsComponent } from './rts/rts.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { PagesComponent } from './pages.component';
import { AuthGuard } from '../guards/auth.guard';

export const routes: Routes = [
  {
    path: 'pages',
    component: PagesComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'rts', pathMatch: 'full' },
      {
        path: 'rts',
        component: RtsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'pages/rts' },
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts